<template>
  <div class="row">
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else class="col_12">
      <div class="d_flex_btwn">
        <h1 class="common_title">
          <span v-if="$route.params.id">Edit Contact</span>
          <span v-else>Create a New Contact</span>
        </h1>
        <span>
          <router-link :to="{ name: 'contacts' }" class="btn btn_black"
            >Back to List</router-link
          >
        </span>
      </div>
      <div class="card border_none">
        <div class="card_body pl_0 pr_0">
          <div class="row">
            <div class="col_6 pr_20">
              <div :class="['form_row', { has_error: errorFor('name') }]">
                <label class="required">Name</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="contact.name"
                  />
                  <v-errors :errors="errorFor('name')"></v-errors>
                </div>
              </div>
              <div :class="['form_row', { has_error: errorFor('email') }]">
                <label class="required">Email</label>
                <div class="form_input">
                  <input
                    type="email"
                    class="form_global"
                    v-model="contact.email"
                  />
                  <v-errors :errors="errorFor('email')"></v-errors>
                </div>
              </div>
              <div :class="['form_row', { has_error: errorFor('title') }]">
                <label>Title</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="contact.title"
                  />
                  <v-errors :errors="errorFor('title')"></v-errors>
                </div>
              </div>
              <div
                :class="['form_row', { has_error: errorFor('description') }]"
              >
                <label>Description</label>
                <div class="form_inline">
                  <text-editor
                    v-model:text="contact['description']"
                    :id="'description'"
                  ></text-editor>
                  <v-errors :errors="errorFor('description')"></v-errors>
                </div>
              </div>
            </div>
            <div class="col_6 pl_20">
              <div :class="['form_row', { has_error: errorFor('status') }]">
                <label class="required">Status</label>
                <div class="form_radio">
                  <input
                    type="radio"
                    id="statusActive"
                    v-model="contact.status"
                    value="1"
                  />
                  <label for="statusActive">Active</label>
                </div>
                <div class="form_radio">
                  <input
                    type="radio"
                    id="statusInactive"
                    v-model="contact.status"
                    value="0"
                  />
                  <label for="statusInactive">Inactive</label>
                </div>
                <v-errors :errors="errorFor('status')"></v-errors>
              </div>
              <div :class="['form_row', { has_error: errorFor('company_id') }]">
                <label>Company</label>
                <div class="form_input">
                  <select class="form_global" v-model="contact.company_id">
                    <option value="">Select Company</option>
                    <option
                      v-for="company in companies"
                      :key="company.id"
                      :value="company.id"
                    >
                      {{ company.company_name }}
                    </option>
                  </select>
                  <v-errors :errors="errorFor('company_id')"></v-errors>
                </div>
              </div>
              <div :class="['form_row', { has_error: errorFor('phone') }]">
                <label>Phone</label>
                <div class="form_inline">
                  <input
                    type="text"
                    class="form_global"
                    v-model="contact.phone"
                  />
                  <v-errors :errors="errorFor('phone')"></v-errors>
                </div>
              </div>
              <div :class="['form_row', { has_error: errorFor('photo') }]">
                <label>Profile Image</label>
                <div class="form_input center_horizontally">
                  <input
                    ref="photo"
                    type="file"
                    class="form_global"
                    accept="image/png, image/gif, image/jpeg"
                    @input="onFileChange($event)"
                  />
                </div>
                <div class="form_row mt_10" v-if="tempFile">
                  <label></label>
                  <div class="inner_img p_relative display_inline">
                    <div class="cross_ic" @click.prevent="deleteFile">
                      <i class="fas fa-times"></i>
                    </div>
                    <img :src="tempFile" alt="" height="100" width="100" />
                  </div>
                </div>
                <div v-else class="form_row mt_10">
                  <label></label>
                  <img
                    v-if="contact.photo"
                    :src="contact.photo"
                    alt=""
                    class=""
                    width="100"
                    height="100"
                  />
                </div>
              </div>
              <div class="form_row">
                <label></label>
                <div class="form_inline">
                  <button
                    class="btn btn_primary"
                    :disabled="lyLoading"
                    @click.prevent="update"
                    v-if="$route.params.id"
                  >
                    Update
                  </button>
                  <button
                    class="btn btn_primary"
                    :disabled="lyLoading"
                    @click.prevent="submit"
                    v-else
                  >
                    Save
                  </button>
                  <router-link
                    v-if="$route.params.id"
                    :to="{ name: 'contacts' }"
                    class="btn btn_transparent has_border_radius ml_10"
                    >Cancel</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoaderMaskComponent from '@/components/LoaderMaskComponent.vue';
import TextEditor from '@/components/shared/TextEditor';
export default {
  name: 'contact-form',
  components: { LoaderMaskComponent, TextEditor },
  data() {
    return {
      lyLoading: false,
      contact: {
        name: '',
        email: '',
        status: 1,
        company_id: '',
        title: '',
        phone: '',
        photo: '',
        description: '',
      },
      tempFile: null,
      companies: [],
    };
  },
  created() {
    if (this.$route.params.id) {
      this.loadData(this.$route.params.id);
    }
    this.getCompanies();
  },
  methods: {
    getCompanies() {
      this.axios.get('/active-companies-for-relation').then(({ data }) => {
        this.companies = data.data;
      });
    },
    onFileChange(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;

      let file = event.target.files[0];
      this.contact.photo = file;

      this.tempFile = URL.createObjectURL(file);
    },
    deleteFile() {
      this.tempFile = null;
      this.contact.photo = null;
      this.$refs.photo.value = null;
    },
    loadData(contactId) {
      this.lyLoading = true;
      this.axios
        .get('/contacts/' + contactId)
        .then((response) => {
          let contactData = response.data.data;
          this.contact.name = contactData.name;
          this.contact.email = contactData.email;
          this.contact.status = contactData.status ? 1 : '0';
          this.contact.company_id = contactData.company_id;
          this.contact.title = contactData.title;
          this.contact.phone = contactData.phone;
          this.contact.photo = contactData.photo;
          this.contact.description = contactData.description;
        })
        .catch(() => {
          this.showFailMsg('No contact exists!');
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    submit() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      Object.keys(this.contact).forEach((key) => {
        formData.append(key, this.contact[key] ? this.contact[key] : '');
      });

      this.axios
        .post('/contacts', formData)
        .then(() => {
          this.resetForm();
          this.showSuccessMsg('Contact Created Successfully!');
          this.$router.push({ name: 'contacts' });
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
          this.showFailMsg(err.response.data.message);
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },

    update() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      formData.append('_method', 'PATCH');

      Object.keys(this.contact).forEach((key) => {
        formData.append(key, this.contact[key] ? this.contact[key] : '');
      });

      this.axios
        .post('/contacts/' + this.$route.params.id, formData)
        .then(() => {
          this.showSuccessMsg('Contact Update Successfully!');
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    resetForm() {
      this.contact = {
        name: '',
        email: '',
        status: 1,
        company_id: '',
        title: '',
        phone: '',
        photo: '',
        description: '',
      };
    },
  },
};
</script>
<style scoped>
.create_item_tab button {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.btn_back {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.font_italic {
  position: relative;
  display: block;
  left: 120px;
  padding-top: 5px;
}
</style>
